import { useMemo, useRef } from 'react'

export default function useInviteForm({ editingInvite, form, onSave, t }) {
  const formRef = useRef()
  const initialValues = useMemo(() => ({
    title: editingInvite?.title || '',
    invite_code: editingInvite?.invite_code || '',
    max_uses: editingInvite ? editingInvite.max_uses == null ? '' : String(editingInvite.max_uses) : '1',
    access_duration_days: editingInvite ? editingInvite.access_duration_days : 30,
  }), [editingInvite])
  const formItems = useMemo(() => [
    { ref: 'title', placeholder: t('staff_essentials_invites_field_title'), required: true, half: true },
    { ref: 'invite_code', placeholder: t('staff_essentials_invites_field_code'), required: true, half: true },
    { ref: 'max_uses', placeholder: t('staff_essentials_invites_field_maximum_uses'), type: 'number', half: true },
    ...(!editingInvite || editingInvite.access_duration_days != null ? [{
      ref: 'access_duration_days', placeholder: t('lite_invite_access_time'), required: true, half: true,
      options: [15, 30, 45, 60].map(days => ({ id: days, title: `${days} ${t('lite_invite_days')}` })),
    }] : []),
  ], [editingInvite, t])
  const save = () => {
    const values = formRef.current?.getForm()
    if (values) onSave({ ...form, ...values })
  }
  return { formRef, formItems, initialValues, save }
}
